
const projectTicker = document.querySelectorAll('.js-project-ticker');

projectTicker.forEach((ticker) => {
  
  const tickerInner = ticker.querySelector('.js-ticker-inner');
  const tickerWidth = tickerInner.offsetWidth;
  const time = ticker.dataset.time;

  tickerInner.childNodes.forEach((x)=> {
    tickerInner.appendChild(x.cloneNode(true));
  });

  rhProjectTickerMove(tickerInner,tickerWidth,time);

});

function rhProjectTickerMove($element, tickerWidth, time) {   
    gsap.fromTo($element, 
        {
            x:0
        }, 
        {
            duration: time, 
            x: -tickerWidth,
            ease:Linear.easeNone, 
            onComplete: rhProjectTickerMove, 
            onCompleteParams:[$element, tickerWidth, time]
        }
    );
}
